import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  private interval: ReturnType<typeof setInterval> | null = null
  private readonly SYMBOLS = ["✦", "✧", "⋆", "·", "✦", "✧"]
  private readonly COLORS = [
    "rgba(255,255,255,VAL)",
  ]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.spawnBurst()
    this.interval = setInterval(() => this.spawnBurst(), 400)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  private spawnBurst() {
    const count = Math.floor(Math.random() * 4) + 4
    for (let i = 0; i < count; i++) {
      setTimeout(() => this.spawnSparkle(), i * 80)
    }
  }

  private spawnSparkle() {
    const el = document.createElement("span")
    const symbol = this.SYMBOLS[Math.floor(Math.random() * this.SYMBOLS.length)]
    const color  = this.COLORS[Math.floor(Math.random() * this.COLORS.length)]
    const size   = (Math.random() * 20 + 10).toFixed(1)
    const x      = (Math.random() * 92 + 2).toFixed(1)
    const y      = (Math.random() * 88 + 4).toFixed(1)
    const dur    = (Math.random() * 1000 + 900).toFixed(0)
    const opacity = (Math.random() * 0.4 + 0.6).toFixed(2)

    el.textContent = symbol
    el.style.cssText = `
      position: absolute;
      left: ${x}%;
      top: ${y}%;
      font-size: ${size}px;
      color: ${color.replace("VAL", opacity)};
      pointer-events: none;
      z-index: 5;
      opacity: 0;
      transform: scale(0.4) rotate(${Math.random() * 60 - 30}deg);
      transition: opacity ${dur}ms ease, transform ${dur}ms ease;
      text-shadow: 0 0 12px ${color.replace("VAL", "1")}, 0 0 24px ${color.replace("VAL", "0.7")};
      will-change: opacity, transform;
    `

    this.element.appendChild(el)

    // Trigger animation in next frame
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = opacity
        el.style.transform = `scale(1) rotate(0deg)`
      })
    })

    // Fade out and remove
    setTimeout(() => {
      el.style.opacity = "0"
      el.style.transform = `scale(0.3) rotate(${Math.random() * 40 - 20}deg)`
      setTimeout(() => el.remove(), parseFloat(dur))
    }, parseFloat(dur) * 0.7)
  }
}
